import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateUserProfileService} from "../services/account/updateUserProfile.service";

const useSaveProfileOnboarding = () => {
  const queryClient = useQueryClient();

  const {mutateAsync, isPending, error} = useMutation({
    mutationKey: ["save-profile-onboarding"],
    mutationFn: async payload => {
      const profilePayload = {
        firstName: payload.firstName,
        lastName: payload.lastName,
        nationalID: payload.nationalID,
        birthDate: payload.birthDate,
      };

      return updateUserProfileService(profilePayload);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["userData"]});
    },
  });

  return {
    saveProfile: mutateAsync,
    isPending,
    error,
  };
};

export default useSaveProfileOnboarding;
